<template>
  <EditorV2 v-if="alibabaIsNew && ['wirelessDesc', 'desc'].includes(this.props.name)" :props="props"></EditorV2>
  <div v-else class="editor">
    <template v-if="['desc'].includes(this.props.name)">
      <div class="tips ft-12">
        为了进一步提升消费者体验，平台新增
        <el-link
          href="https://helpcenter.taobao.com/servicehall/knowledge_detail?kwdContentId=445704076455375872&searchKey=9fab549735554ba89d1659d54a7a6baf1&source=6&spm=service_hall.25034502.shcSearchResult_kuph4mbg.445704076455375872&hcSessionId=3-1281-30bd039c-6433-4c54-ac29-f5719e3c4ca9"
          target="_blank"
          >《商品详情页主图设计规范》</el-link
        >， 请参考该规范设计商品主图
      </div>
    </template>
    <el-button v-if="isWirelessDesc" style="margin-bottom: 10px" @click="importPCdesc">导入电脑端描述</el-button>
    <el-button v-if="showImportImages" style="margin-bottom: 10px" @click="importImages">导入电脑端宝贝图片</el-button>
    <Editor
      :id="key"
      :ref="key"
      :limitImgSize="1 * 1024 * 1024"
      :value="alibabaForm[key]"
      :menus="menus"
      @change="onChange"
      @fullScreenChange="editorFullScreenChange"
    />
  </div>
</template>

<script>
import { editor_mixin } from '@/components/Editor/index.js';
import storeMixins from '../store-mixins';
import EditorV2 from './indexV2.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    EditorV2,
  },
  mixins: [storeMixins, editor_mixin],
  props: ['props'],
  inject: ['alibabaFormVm'],
  computed: {
    ...mapGetters(['alibabaIsNew']),
    key() {
      return this.props.name;
    },
    isWirelessDesc() {
      return this.props.name === 'wirelessDesc';
    },
    showImportImages() {
      return ['wirelessDesc', 'desc'].includes(this.props.name);
    },
    menus() {
      // 手机端只允许上传图片
      return this.isWirelessDesc ? ['image'] : [];
    },
  },
  watch: {
    editorFormItenClass: {
      immediate: true,
      handler(v) {
        if (!this.$el || !this.$el.parentNode) {
          return;
        }
        this.fixFullScreenStyle();
      },
    },
  },
  methods: {
    onChange(v) {
      const newFormFields = {};
      newFormFields[this.key] = v;
      this.updateAlibabaForm(newFormFields);
    },
    importPCdesc() {
      this.onChange(this.alibabaForm.desc);
      // 初始化好的编辑器需要调用内置方法更新文本
      this.$nextTick(() => {
        this.$refs[this.key].init_text();
      });
    },
    // 倒入宝贝详情图
    importImages() {
      let images = this.alibabaForm.images;
      if (!images || !images.length) {
        return this.$message.error('电脑端宝贝图片不存在');
      }
      this.$refs[this.key].addImages(images);
      this.$message.success('导入电脑端宝贝图片成功');
    },
    // 修复富文本全屏的及非全屏层级问题
    fixFullScreenStyle() {
      let v = this.editorFormItenClass;
      if (v[1].nofull) {
        this.$el.parentNode.style.zIndex = 1;
      } else {
        this.$el.parentNode.style.zIndex = '';
      }
    },
  },
  mounted() {
    this.fixFullScreenStyle();
  },
};
</script>

<style lang="scss">
#editor-wirelessDesc {
  .w-e-text {
    text-align: center;
    img {
      display: block;
      margin: 0 auto;
    }
  }
}
</style>